import DOMPurify from "dompurify";

// Admin-authored rich text is sanitised before rendering (defence in depth).
export const safeHtml = (html) => ({
  __html: DOMPurify.sanitize(html || "", { ADD_ATTR: ["target"] }),
});
